import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function ClassroomCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Procesando autenticación...');

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const error = searchParams.get('error');
      const userId = localStorage.getItem('user_id_for_classroom');
      const userType = localStorage.getItem('user_type_for_classroom') || 'teacher';

      if (error) {
        setStatus('error');
        setMessage('Autenticación cancelada o falló');
        setTimeout(() => navigate('/dashboard'), 3000);
        return;
      }

      if (!code) {
        setStatus('error');
        setMessage('Código de autorización no encontrado');
        setTimeout(() => navigate('/dashboard'), 3000);
        return;
      }

      if (!userId) {
        setStatus('error');
        setMessage('Error: ID de usuario no encontrado');
        setTimeout(() => navigate('/dashboard'), 3000);
        return;
      }

      try {
        await axios.post(`${BACKEND_URL}/api/classroom/callback`, null, {
          params: { 
            code, 
            user_id: userId,
            user_type: userType
          }
        });

        setStatus('success');
        setMessage('¡Google Classroom conectado exitosamente!');
        localStorage.removeItem('user_id_for_classroom');
        localStorage.removeItem('user_type_for_classroom');
        setTimeout(() => navigate('/dashboard'), 2000);
      } catch (error) {
        console.error('Error in callback:', error);
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Error al conectar con Classroom');
        setTimeout(() => navigate('/dashboard'), 3000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary to-purple-900 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        {status === 'processing' && (
          <>
            <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-4 border-primary mb-4"></div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Conectando con Classroom</h2>
            <p className="text-gray-600">{message}</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="text-6xl mb-4">✅</div>
            <h2 className="text-2xl font-bold text-green-600 mb-2">¡Conectado!</h2>
            <p className="text-gray-600">{message}</p>
            <p className="text-sm text-gray-500 mt-4">Redirigiendo al dashboard...</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="text-6xl mb-4">❌</div>
            <h2 className="text-2xl font-bold text-red-600 mb-2">Error</h2>
            <p className="text-gray-600">{message}</p>
            <p className="text-sm text-gray-500 mt-4">Redirigiendo al dashboard...</p>
          </>
        )}
      </div>
    </div>
  );
}

export default ClassroomCallback;
